import React from 'react'
import { TextLink } from 'baby-design'
import { SimpleShipping } from 'baby-design/icons'
import { shippingConsolidationHelpPath } from 'lib/urls'
import css from './ConsolidatedShippingEnrollmentBanner.styles.scss'

const ConsolidatedShippingEnrollmentBanner: React.FC = () => (
  <div
    className={css.ConsolidatedShippingEnrollmentBanner}
    data-testid="simple-shipping-enrollment-banner"
  >
    <div className={css.ConsolidatedShippingEnrollmentBanner__icon__container}>
      <SimpleShipping
        className={css.ConsolidatedShippingEnrollmentBanner__icon}
      />
    </div>
    <div className={css.ConsolidatedShippingEnrollmentBanner__textContainer}>
      <div className={css.ConsolidatedShippingEnrollmentBanner__titleAndBody}>
        <span className={css.ConsolidatedShippingEnrollmentBanner__title}>
          You're enrolled in Simple Shipping
        </span>
        <span className={css.ConsolidatedShippingEnrollmentBanner__body}>
          Shipments from the Babylist Shop are packaged into fewer boxes every 2
          weeks.
        </span>
      </div>
      <TextLink
        underline
        href={shippingConsolidationHelpPath}
        innerContentClassName={css.ConsolidatedShippingEnrollmentBanner__link}
        rel="noopener noreferrer"
        size="sm"
        target="_blank"
      >
        Learn more
      </TextLink>
    </div>
  </div>
)

export default ConsolidatedShippingEnrollmentBanner
